// extracted by mini-css-extract-plugin
module.exports = {"container":"Theme_container__UQ_mr","sunIcon":"Theme_sunIcon__31Zw8","moonIcon":"Theme_moonIcon__1yG2A","switch":"Theme_switch__3OAtP","switchLabel":"Theme_switchLabel__u4R9e"};